import type { QuestionnaireConfigurationDTO } from '../model';
import { questionnaireClient } from '.';
import { QueryKey } from '@/types/query';
import { useQuery } from '@tanstack/react-query';

const QUERY_KEY = [QueryKey.useQuestionnaireConfigurationQuery, { jobId: 0 }] as const;

export function getQuestionnaireConfigurationQueryKey(jobId: number) {
  return [QUERY_KEY[0], { jobId }] as const;
}

export async function questionnaireConfigurationQueryFn({
  queryKey,
}: {
  queryKey: readonly [string, { jobId: number }];
}): Promise<QuestionnaireConfigurationDTO> {
  const { data } = await questionnaireClient.ensureQuestionnaireConfiguration({ job_id: queryKey[1].jobId });
  return data;
}

export function useQuestionnaireConfigurationQuery(jobId: number | undefined, options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? Boolean(jobId);
  return useQuery({
    queryKey: getQuestionnaireConfigurationQueryKey(jobId ?? 0),
    enabled: Boolean(jobId) && enabled,
    queryFn: questionnaireConfigurationQueryFn,
  });
}
